import { Component } from '@angular/core';
import { TranslationService } from '../../services/common/translation.service';
import { AnnouncementService } from '../../services/announcements/announcement.service';
import { AnnouncementResponse } from '../../models/announcements/AnnouncementResponse';

@Component({
  selector: 'announcements',
  template: require('./../../templates/common/announcements.component.html'),
  providers: [AnnouncementService, TranslationService]
})
export class AnnouncementsComponent {

  announcements: Array<AnnouncementResponse>;
  activeAnnouncement: AnnouncementResponse | null;

  readFullArticle: string;
  closeArticle: string;

  constructor(private announcementService: AnnouncementService, private translationService: TranslationService) {

  }

  ngOnInit() {
    this.initTranslations();
    this.loadAnnouncements();
  }

  private initTranslations() {
    this.translationService.translate('announcements.readFullArticle', 'Read More', (data) => this.readFullArticle = data);
    this.translationService.translate('announcements.closeArticle', 'Close Article', (data) => this.closeArticle = data);
  }

  private loadAnnouncements() {
    var language = TranslationService.currentCulture.code;
    var result = this.announcementService.getAnnouncements(language);
    result.subscribe(response => {
      this.announcements = response.data;
    });
  }

  private showAnnouncement(announcement: AnnouncementResponse) {
    this.activeAnnouncement = announcement;
    document.body.classList.add('modal-open');
  }

  private closeAnnouncement() {
    this.activeAnnouncement = null;
    document.body.classList.remove('modal-open');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/announcements.component.ts